"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAppStateContext = exports.AppStateProvider = exports.AppStateContext = void 0;
exports.withAppState = withAppState;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _appState = require("@insided/shared/utils/appState");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var createAppStateContext = function createAppStateContext(state) {
  return _objectSpread({}, state);
};

exports.createAppStateContext = createAppStateContext;

var defaultState = _appState.appStateSchema.parse(undefined);

var defaultContext = createAppStateContext(defaultState);
var AppStateContext = (0, _preactCompat.createContext)(defaultContext);
exports.AppStateContext = AppStateContext;

var AppStateProvider = function AppStateProvider(_ref) {
  var appState = _ref.appState,
      children = _ref.children;
  var appStateContextValue = createAppStateContext(appState);
  return (0, _preact.h)(AppStateContext.Provider, {
    value: appStateContextValue
  }, children);
};

exports.AppStateProvider = AppStateProvider;

function withAppState(WrappedComponent) {
  return /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(WithAppStateWrapper, _Component);

    var _super = _createSuper(WithAppStateWrapper);

    function WithAppStateWrapper() {
      (0, _classCallCheck2.default)(this, WithAppStateWrapper);
      return _super.apply(this, arguments);
    }

    (0, _createClass2.default)(WithAppStateWrapper, [{
      key: "render",
      value: function render() {
        var props = this.props;
        return (0, _preact.h)(AppStateContext.Consumer, null, function (appState) {
          return (0, _preact.h)(WrappedComponent, (0, _extends2.default)({}, props, appState));
        });
      }
    }]);
    return WithAppStateWrapper;
  }(_preact.Component);
}